import { Badge, Heading, Text, Tooltip, View, logger } from '@fold-dev/core'
import { useEffect, useMemo, useState } from 'react'
import { useNavigate, useParams } from 'react-router'
import { Block } from '../../components'
import { getCachedProjectView, getInitials } from '../../helpers'
import { useProjects, useWorkspaceUsers } from '../../hooks/api.hooks'
import { useAppStore } from '../../store/app'
import { Project } from './project'

export const StarredProject = ({ project }) => {
    const { workspaceId, projectId } = useParams()
    const navigate = useNavigate()
    const user = useAppStore((state) => state.user)
    const unreads = useAppStore((state) => state.unreads)
    const sidebar = useAppStore((state) => state.sidebar)
    const actions = useAppStore((state) => state.actions)
    const thread = useAppStore((state) => state.thread)
    const notifications = useAppStore((state) => state.notifications)
    const hasUnread = useMemo(() => !!unreads.find(({ projectId }) => projectId == project.id), [unreads])
    const showBadge = useMemo(
        () => hasUnread || (notifications[project.id] || []).some((n) => !n.read),
        [project.id, notifications, hasUnread]
    )
    const projectName = useMemo(
        () => (project.isPrivate ? getInitials(project.projectUsers, user?.id) : project.name),
        [user, project]
    )
    const projectImage = useMemo(
        () =>
            project.isPrivate
                ? project.projectUsers.length == 2
                    ? project.projectUsers.filter((u) => u.id != user?.id)![0].image
                    : null
                : null,
        [user?.id, project.isPrivate, project.projectUsers]
    )
    const projectUserId = useMemo(
        () =>
            project.isPrivate
                ? project.projectUsers.length == 2
                    ? project.projectUsers.filter((u) => u.id != user?.id)![0].id
                    : null
                : null,
        [user?.id, project.isPrivate, project.projectUsers]
    )

    const handleNavigate = () => {
        actions.setMainLoading(true)
        actions.setMessages([])
        //actions.setSections([])
        //actions.setSections(getFastCache(getFastCacheKey(workspaceId, project.id)), false)

        if (project.isChannel || !!thread.id || (!project.isChannel && sidebar == 'tasks')) {
            if (!!sidebar) actions.setSidebar('overview')
            actions.setThread({ id: null, messages: [] })
        }

        navigate(`/app/workspace/${workspaceId}/c/${project.id}/${getCachedProjectView(project.id)}`)
    }

    return (
        <div
            className="reveal-on-hover"
            style={{
                position: 'relative',
                outline:
                    projectId == project.id ? '2px solid ' + (project.color || 'var(--f-color-accent)') : undefined,
                borderRadius: project.isPrivate ? 50 : 'var(--f-radius-lg)',
                outlineOffset: 1,
            }}>
            {/*   
            <div
                style={{ position: 'absolute', right: -10, top: 0, zIndex: 10 }} 
                onClick={(e) => {
                    stopEvent(e)
                    onUnstar(project.id)
                }}
                className="reveal-on-hover-target">
                <Icon 
                    icon={XCircleIcon} 
                    color="var(--f-color-danger)"

                />
            </div> 
            */}
            <Tooltip
                anchor="top-center"
                text={projectName}>
                <View>
                    <Block
                        isPrivate={project.isPrivate}
                        //isChannel={project.isChannel}
                        otherUserId={projectUserId}
                        name={projectName}
                        color={project.color}
                        //icon={project.icon}
                        src={projectImage}
                        size="lg"
                        className="f-buttonize"
                        onClick={handleNavigate}
                    />
                </View>
            </Tooltip>

            {showBadge && (
                <Badge
                    anchor="top-right"
                    width={7}
                    height={7}
                    zIndex={1}
                    variant="accent"
                    bgToken="danger"
                    style={{
                        '--f-badge-dot-distance': '1px',
                        'outline': '2px solid var(--f-color-background)',
                    }}
                />
            )}
        </div>
    )

    return (
        <Project
            id={project.id}
            name={projectName}
            icon={project.icon}
            color={project.color}
            isClosed={false}
            onNavigate={() => navigate(`/app/workspace/${workspaceId}/today`)}
            active={projectId == project.id}
        />
    )
}

export const StarredList = () => {
    const { workspaceId } = useParams()
    const workspace = useAppStore((state) => state.workspace)
    const projects = useAppStore((state) => state.projects)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<any>('')
    const projectsAPI = useProjects()
    const workspaceUsersAPI = useWorkspaceUsers()
    const actions = useAppStore((state) => state.actions)
    const starred = useAppStore((state) => state.starred)
    const allStarred = useMemo(() => projects.filter((project) => starred.includes(project.id)), [starred, projects])

    const fetchData = async () => {
        setLoading(true)
        setError(null)

        try {
            const { starred } = await workspaceUsersAPI.getOne(workspaceId, workspace.workspaceUserId)
            actions.setStarred(starred)
            setLoading(false)
        } catch (e) {
            logger(e)
            setLoading(false)
            setError('Could not fetch teams')
        }
    }

    useEffect(() => {
        if (workspaceId && workspace.workspaceUserId) fetchData()
    }, [workspaceId, workspace.workspaceUserId])

    return (
        <>
            {allStarred.map((project, index) => (
                <StarredProject
                    key={index}
                    project={project}
                />
            ))}
        </>
    )
}

export const Starred = () => {
    const starred = useAppStore((state) => state.starred)

    return (
        <View
            display={!!starred && !starred.length ? 'none' : 'block'}
            width="100%"
            position="relative"
            color="var(--f-color-text-weaker)"
            p="1.5rem 0.5rem 1rem 1.5rem">
         {/*    <Heading
                as="h6"
                className="nav-section-heading f-ellipsis"
                p="0 1.7rem 1rem 0.25rem">
                Starred
            </Heading> */}
            <View
                row
                justifyContent="flex-start"
                wrap="wrap"
                gap="0.5rem">
                <StarredList />
            </View>
        </View>
    )

    /*     return (
        <>
            <br />
            {starred.map((project, index) => (
                <StarredProject
                    key={index}
                    project={project}
                />
            ))}
        </>
    ) */
}
